import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
  Alert,
  TextField,
} from '@mui/material';
import { Replay as ReplayIcon } from '@mui/icons-material';

const ReaperturaDemanda = ({ 
  open, 
  onClose, 
  onSuccess, 
  demanda, 
  token 
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [observaciones, setObservaciones] = useState('');

  const handleConfirmReapertura = async () => {
  if (!demanda) return;

  try {
    setLoading(true);
    setError(null);

    // Construir la URL dinámica con el id del trámite
    const url = `https://bei360.injupemp.gob.hn:8444/api/tramite/reabrir/${demanda.tramiteid}/`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({
        motivo_reapertura: observaciones || `Demanda reabierta el ${new Date().toLocaleDateString()}`,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Error al reabrir el trámite');
    }

    const data = await response.json();

    // Actualizar el estado local
    onSuccess({
      ...demanda,
      estado: 'Activo',
      observaciones: observaciones || data.motivo_reapertura,
    });

  } catch (err) {
    console.error('Error al reabrir trámite:', err);
    setError(err.message || 'Ocurrió un error al reabrir el trámite');
  } finally {
    setLoading(false);
  }
};


  const handleClose = () => {
    setError(null);
    setObservaciones('');
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="reapertura-dialog-title"
    >
      <DialogTitle id="reapertura-dialog-title" 
      sx={{  textAlign: 'center',
          fontWeight: 'bold',
          fontSize: '1.2rem',
          color: 'white',
          backgroundColor: '#19438C',
          py: 2 
          }}>
        <Box display="flex" alignItems="center" gap={1}>
          <ReplayIcon color="white" />
          <Typography variant="h7" component="span">
            Reaperturar Demanda {demanda?.tramiteid}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ mt: 2 }}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <Typography variant="body1" gutterBottom>
          ¿Está seguro que desea reabrir la siguiente demanda?
        </Typography>

        <Box sx={{ bgcolor: '#f8f9fa', p: 2, borderRadius: 1, mt: 2 }}>

          <Typography variant="subtitle2" color="text.secondary">
            Demandante: <strong>{demanda?.nombredemandante || 'N/A'}</strong>
          </Typography>
           <Typography variant="subtitle2" color="text.secondary">
            Demandado: <strong>{demanda?.nombredemandado || 'N/A'}</strong>
          </Typography>
          <Typography variant="subtitle2" color="text.secondary">
            Expediente: <strong>{demanda?.expediente}</strong>
          </Typography>
          <Typography variant="subtitle2" color="text.secondary">
            Estado actual: <strong style={{ color: '#4CAF50' }}>{demanda?.estado}</strong>
          </Typography>
        </Box>

        <TextField
          fullWidth
          multiline
          rows={3}
          label="Motivo de reapertura"
          value={observaciones}
          onChange={(e) => setObservaciones(e.target.value)}
          margin="normal"
          variant="outlined"
          placeholder="Ingrese las razones para reabrir esta demanda..."
        />

        <Alert severity="info" sx={{ mt: 2 }}>
          Esta acción cambiará el estado de la demanda a "Activo" y permitirá continuar con el proceso legal.
        </Alert>
      </DialogContent>

      <DialogActions sx={{ p: 3, gap: 1 }}>
        <Button 
          onClick={handleClose} 
          color="error"
          disabled={loading}
        >
          Cancelar
        </Button>
        <Button 
          onClick={handleConfirmReapertura} 
          variant="contained"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={16} /> : <ReplayIcon />}
        >
          {loading ? 'Reabriendo...' : 'Reabrir Demanda'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReaperturaDemanda;